import Dropdown from "../../Dropdown";
import css from "./DropdownInput.module.css";

export default function DropdownInput({ inputProps, styles, classes, config = {}, children }) {
	const { options = [], onOptionSelect, ...dropdownProps } = config;
	return (
		<Dropdown
			{...dropdownProps}
			{...inputProps}
			styles={{ ...styles, root: styles.dropdown }}
			classes={{ ...classes, root: classes.dropdown, field: classes.field ?? css.field }}
		>
			{children || (({ closeMenu }) => (
				<>
					{options.map((option) => (
						<button
							type="button"
							key={option.value}
							className={classes.option ?? css.option}
							style={styles.option}
							onClick={(event) => {
								event.stopPropagation();
								onOptionSelect?.(option);
								closeMenu();
							}}
						>
							{option.label}
						</button>
					))}
				</>
			))}
		</Dropdown>
	);
}
